import { Link } from "react-router-dom";
import { useEffect } from "react";

const footerColumns = [
  {
    title: "浏览内容",
    links: [
      { label: "最新电影", to: "/category/movie" },
      { label: "热播电视剧", to: "/category/tv" },
      { label: "影视资讯", to: "/news" },
    ],
  },
  {
    title: "帮助与条款",
    links: [
      { label: "关于我们", to: "/about" },
      { label: "使用条款", to: "/about#terms" },
      { label: "隐私政策", to: "/about#privacy" },
    ],
  },
];

const socials = [
  { icon: "ri-weibo-fill", label: "微博" },
  { icon: "ri-wechat-fill", label: "微信" },
  { icon: "ri-bilibili-fill", label: "哔哩哔哩" },
  { icon: "ri-douban-fill", label: "豆瓣" },
];

export default function Footer() {
  useEffect(() => {
    /* reserved for future footer analytics */
  }, []);

  return (
    <footer className="w-full mt-20 bg-primary-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-12 md:py-14">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 md:gap-8">
          <div className="md:col-span-2 max-w-md">
            <div className="flex items-center gap-2.5 mb-4">
              <span className="w-9 h-9 rounded-md bg-accent-500 flex items-center justify-center text-primary-950 text-lg">
                <i className="ri-play-fill" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-black text-background-50">CC视频</span>
                <span className="text-[10px] tracking-[0.2em] font-label text-background-400">
                  CINEMA CLOUD
                </span>
              </span>
            </div>
            <p className="text-sm leading-relaxed text-background-300">
              CC视频是面向影视爱好者的内容聚合平台，提供电影、电视剧的分类浏览、筛选检索与影视资讯阅读。
              我们相信，找到一部对的作品，和看完它一样重要。
            </p>
            <div className="flex items-center gap-2 mt-5">
              {socials.map((s) => (
                <button
                  key={s.label}
                  type="button"
                  aria-label={s.label}
                  title={s.label}
                  className="w-9 h-9 rounded-md bg-background-50/10 flex items-center justify-center text-background-200 hover:bg-accent-500 hover:text-primary-950 transition-colors cursor-pointer"
                >
                  <i className={`${s.icon} text-base w-4 h-4 flex items-center justify-center`} />
                </button>
              ))}
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="font-heading text-sm font-bold text-background-50 mb-4">
                {col.title}
              </h4>
              <ul className="space-y-2.5">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link
                      to={l.to}
                      className="text-sm text-background-300 hover:text-accent-400 transition-colors"
                    >
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-10 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between">
          <p className="text-xs text-background-400">
            © 2026 CC视频 Cinema Cloud · 本站为演示站点，所有影片信息与播放功能仅供参考演示。
          </p>
          <p className="text-xs text-background-400">
            联系邮箱：service@ccvideo.demo &nbsp;|&nbsp; 客服电话：400-000-0000
          </p>
        </div>
        <p className="mt-3 text-xs text-background-500 leading-relaxed">
          免责声明：本平台不提供任何影视作品的在线播放与下载服务，站内海报、简介等素材仅用于界面演示，
          相关权利归原著作权人所有。
        </p>
      </div>
    </footer>
  );
}